// Core Imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

// Angular Meterial Imports
import { MatDialogModule} from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// ag-grid
import { AgGridModule } from 'ag-grid-angular';


//date time picker
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS, OwlNativeDateTimeModule} from 'ng-pick-datetime';

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  timePickerInput: {hour: 'numeric', minute: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

// Crime/Fire Log App Imports
import { AppComponent } from './app.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { CrimeLogComponent } from './crime-log/crime-log.component';
import { FireLogComponent } from './fire-log/fire-log.component';
import { CrimeLogFormComponent } from './crime-log-form/crime-log-form.component';
import { DeleteLogComponent } from './delete-log/delete-log.component';
import { FireLogFormComponent } from './fire-log-form/fire-log-form.component';
import { BatsConfirmComponent } from './lib/bats-confirm/bats-confirm.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BATSCoreService } from './services/batscore.service';
import { BatsBldgLookupComponent } from './lib/form-fields/bats-bldg-lookup/bats-bldg-lookup.component';




const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let formats = {}
if(isIEOrEdge){
  formats = {
    parseInput: 'LL LT',
    fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false},
        datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
        timePickerInput: {hour: 'numeric', minute: 'numeric', hour12: false},
        monthYearLabel: {year: 'numeric', month: 'short'},
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'},
      };
}
else{
  formats = {
  parseInput: 'LL LT',
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'},
      datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
      timePickerInput: {hour: 'numeric', minute: 'numeric', hourCycle: 'h23'},
      monthYearLabel: {year: 'numeric', month: 'short'},
      dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
      monthYearA11yLabel: {year: 'numeric', month: 'long'},
    };
}
export const MY_CUSTOM_FORMATS = formats;
 
  
  

@NgModule({
  declarations: [
    AppComponent,
    TopBarComponent,
    CrimeLogComponent,
    FireLogComponent,
    CrimeLogFormComponent,
    DeleteLogComponent,
    FireLogFormComponent,
    BatsConfirmComponent,
    BatsBldgLookupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AgGridModule.withComponents([])
  ],
  entryComponents: [
    CrimeLogFormComponent,
    FireLogFormComponent,
    DeleteLogComponent
  ],
  providers: [
    {provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS},
    { provide: 'APP', useValue: 'CRIME_FIRE' },
    { provide: 'API_BASE', useValue: '' },
    BATSCoreService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
